module.exports = "<span class=\"badge {{getStatus().css}}\">{{getStatus().label}}</span>"